import QuickView from '../product/quickView';
import calculate from '../../utils/calculate';
import { loadRecommendationsCarousel } from '../../einsteinCarousel';

const listener = require('../../utils/listener');

document.addEventListener('DOMContentLoaded', (e) => {
  new QuickView().init();

  if (window.dataLayer) {
    listener.default.dataLayerAddToCartHandler();
  }
});

export default class Cart {
  constructor() {
    this.checkoutContinue = '.checkout-continue';
  }

  init() {
    listener.default.setStickyDisplay(document.getElementsByClassName('checkout-continue')[0], 575);

    this.setAddCoupon();
    this.handlerProgressBar();
    loadRecommendationsCarousel();
  }

  handlerProgressBar() {
    $('body').on('cart:update', () => {
      const progress = require('../../components/progress');

      const $shippingContainer = $('.progress-container');
      const $miniCart = $('.minicart .minicart-subtotal');
      const $valueShipping = $shippingContainer.find('.value-shipping').data('value');
      const $cartContainer = $('.cart.cart-page');
      const formatValueSubTotal = parseFloat($miniCart.attr('value').replace(',', '.'));
      const subTotals = calculate.progress(formatValueSubTotal, $valueShipping);
      progress.default.build(subTotals, formatValueSubTotal, $cartContainer);
    });
  }

  setAddCoupon() {
    const _this = this;

    $('body').on('click', '.coupon-error-more-info', function (e) {
      e.preventDefault();
      e.stopPropagation();
      const $tooltip = $('.coupon-error-tooltip');
      const isHidden = !$tooltip.is(':visible');
      $tooltip.toggle(isHidden).attr('aria-hidden', isHidden ? 'false' : 'true');
      $(this).attr('aria-expanded', isHidden ? 'true' : 'false');
    });

    $('body').on('click', '.coupon-error-tooltip-close', function (e) {
      e.preventDefault();
      $('.coupon-error-tooltip').hide().attr('aria-hidden', 'true');
      $('.coupon-error-more-info').attr('aria-expanded', 'false').trigger('focus');
    });

    $(document).on('click', function (e) {
      if (!$(e.target).closest('.coupon-error-tooltip').length) {
        $('.coupon-error-tooltip').hide().attr('aria-hidden', 'true');
        $('.coupon-error-more-info').attr('aria-expanded', 'false');
      }
    });

    $('body').on('click', '.promo-code-btn', function (e) {
      e.preventDefault();
      $.spinner().start();

      const $form = $('.promo-code-form');
      const formControl = $form.find('.form-control');
      const couponMissingError = $('.coupon-missing-error');
      const couponErrorMsg = $('.coupon-error-message');

      const $couponErrorMoreInfo = $('.coupon-error-more-info-container');
      couponMissingError.hide();
      couponErrorMsg.empty();
      $couponErrorMoreInfo.addClass('d-none');
      $('.coupon-error-tooltip').hide().attr('aria-hidden', 'true');

      $('.coupon-code-field').val($('.coupon-code-field').val().replace(/\s+/g, '').trim());

      if (!$('.coupon-code-field').val()) {
        formControl.addClass('is-invalid');
        formControl.attr('aria-describedby', 'missingCouponCode');
        couponMissingError.show();
        $.spinner().stop();
        return false;
      }

      formControl.removeClass('is-invalid');
      couponErrorMsg.empty();
      $('body').trigger('promotion:beforeUpdate');

      $.ajax({
        url: $form.attr('action'),
        type: 'GET',
        dataType: 'json',
        data: $form.serialize(),
        success: function (data) {
          if (data.error) {
            formControl.addClass('is-invalid');
            formControl.attr('aria-describedby', 'invalidCouponCode');
            couponErrorMsg.empty().append(data.errorMessage);
            $couponErrorMoreInfo.removeClass('d-none');
            $('body').trigger('promotion:error', data);
          } else {
            $('.coupons-and-promos').empty().append(data.totals.discountsHtml);
            _this.updateCartTotals(data);
            _this.updateApproachingDiscounts(data.approachingDiscounts);
            _this.validateBasket(data);
            $('body').trigger('promotion:success', data);
          }
          $('.coupon-code-field').val('');
          $.spinner().stop();
        },
        error: function (err) {
          $('body').trigger('promotion:error', err);
          if (err.responseJSON && err.responseJSON.redirectUrl) {
            window.location.href = err.responseJSON.redirectUrl;
          } else {
            _this.createErrorNotification(err.errorMessage);
            $.spinner().stop();
          }
        }
      });
      return false;
    });
  }

  /**
   * re-renders the order totals and the number of items in the cart
   * @param {Object} data - AJAX response from the server
   */
  updateCartTotals(data) {
    if (!data && !data.totals && !data.resources && !data.items) return;

    const {
      totalShippingCost,
      totalTax,
      grandTotal,
      subTotal,
      subTotalIncludingOrderDiscount,
      orderLevelDiscountTotal,
      shippingLevelDiscountTotal,
      discountsHtml
    } = data.totals;

    $('.number-of-items .number').empty().append(data.resources.numberOfItems);
    $('.shipping-cost').empty().append(totalShippingCost.formatted);
    $('.tax-total').empty().append(totalTax.formatted);
    $('.grand-total').empty().append(grandTotal.formatted);
    $('.sub-total').empty().append(subTotal.formatted);
    $('.sub-total-incl-discount').empty().append(subTotalIncludingOrderDiscount.formatted);
    $('.estimated-total .sub-total')
      .empty()
      .append(subTotalIncludingOrderDiscount.formatted || subTotal.formatted);
    $('.minicart-quantity').empty().append(data.numItems);
    $('.minicart-link').attr({
      'aria-label': data.resources.minicartCountOfItems,
      title: data.resources.minicartCountOfItems
    });

    if (orderLevelDiscountTotal.value > 0) {
      $('.order-discount').removeClass('hide-order-discount');
      $('.order-discount-total')
        .empty()
        .append('- ' + orderLevelDiscountTotal.formatted);
    } else {
      $('.order-discount').addClass('hide-order-discount');
    }

    if (shippingLevelDiscountTotal.value > 0) {
      $('.shipping-discount').removeClass('hide-shipping-discount');
      $('.shipping-discount-total')
        .empty()
        .append('- ' + shippingLevelDiscountTotal.formatted);
    } else {
      $('.shipping-discount').addClass('hide-shipping-discount');
    }

    if (grandTotal.value >= parseFloat($('.cart-wrapper').attr('data-freeshipping-value'))) {
      $('.free-shipping-row').removeClass('d-none');
    } else {
      $('.free-shipping-row').addClass('d-none');
    }

    data.items.forEach(function (item) {
      if (orderLevelDiscountTotal.value > 0) {
        $('.coupons-and-promos').empty().append(discountsHtml);
      }
      if (item.renderedPromotions) {
        $('.item-' + item.UUID)
          .empty()
          .append(item.renderedPromotions);
      } else {
        $('.item-' + item.UUID).empty();
      }
      $('.uuid-' + item.UUID + ' .unit-price')
        .empty()
        .append(item.renderedUnitPrice);
      $('.line-item-price-' + item.UUID + ' .unit-price')
        .empty()
        .append(item.renderedUnitPrice);
      $('.item-total-' + item.UUID)
        .empty()
        .append(item.priceTotal.renderedPrice);
    });
  }

  /**
   * re-renders the approaching discount messages
   * @param {Object} approachingDiscounts - updated approaching discounts for the cart
   */
  updateApproachingDiscounts(approachingDiscounts) {
    let html = '';
    $('.approaching-discounts').empty();
    if (approachingDiscounts.length > 0) {
      approachingDiscounts.forEach(function (item) {
        html += '<div class="single-approaching-discount text-center">' + item.discountMsg + '</div>';
      });
    }
    $('.approaching-discounts').append(html);
  }

  /**
   * Checks whether the basket is valid. if invalid displays error message and disables
   * checkout button
   * @param {Object} data - AJAX response from the server
   */
  validateBasket(data) {
    if (!data) return;

    if (data.valid && data.valid.error) {
      if (data.valid.message) {
        const errorHtml =
          '<div class="alert alert-danger alert-dismissible valid-cart-error ' +
          'fade show" role="alert">' +
          '<button type="button" class="close" data-dismiss="alert" aria-label="Close">' +
          '<span aria-hidden="true">&times;</span>' +
          '</button>' +
          data.valid.message +
          '</div>';

        $('.cart-error').append(errorHtml);
      } else {
        $('.cart')
          .empty()
          .append(
            '<div class="row"> ' +
              '<div class="col-12 text-center"> ' +
              '<h1>' +
              data.resources.emptyCartMsg +
              '</h1> ' +
              '</div> ' +
              '</div>'
          );
        $('.number-of-items .number').empty().append(data.resources.numberOfItems);
        $('.minicart-quantity').empty().append(data.numItems);
        $('.minicart-link').attr({
          'aria-label': data.resources.minicartCountOfItems,
          title: data.resources.minicartCountOfItems
        });
        $('.minicart .popover').empty();
        $('.minicart .popover').removeClass('show');
      }

      $('.checkout-btn').addClass('disabled');
    } else {
      $('.checkout-btn').removeClass('disabled');
    }
  }

  /**
   * re-renders the order totals and the number of items in the cart
   * @param {Object} message - Error message to display
   */
  createErrorNotification(message) {
    const errorHtml =
      '<div class="alert alert-danger alert-dismissible valid-cart-error ' +
      'fade show" role="alert">' +
      '<button type="button" class="close" data-dismiss="alert" aria-label="Close">' +
      '<span aria-hidden="true">&times;</span>' +
      '</button>' +
      message +
      '</div>';

    $('.cart-error').append(errorHtml);
  }
}
